// ----------------------------------------------------------------------------
// Component: Hero Banner Brand
// ----------------------------------------------------------------------------

import 'snippets/background-media/background-media';
import './_hero-banner-brand.scss';
